'use client'
import {Button} from '@local/ui/components'
import {event} from '@local/utils/gtm'
import React from 'react'

const BannerButton = ({slug}: {slug: string}) => {
	return (
		<Button
			title='Find a Room' label='Find a Room' small type='button' variant='secondary' onClick={() => {
				event('select_content', {
					ecommerce: {
						content_type: 'product',
						content_id: slug,
					},
				})
			}} className='text-12 font-medium' href={slug} />
	)
}

export default BannerButton
